import {observable, action, computed} from 'mobx';
import {ISharingModeActions, ISignedData} from '../../../services/ts-sharing-service/contracts';

export interface ISharingWidget {
    _id?: string;
    url?: string;
    type?: 'url' | 'dataUrl' | 'text';
    inProgress: boolean;
    signedData?: ISignedData;
    useOriginalImage?: boolean;
    data?: string;
    fileName?: string;
    tryAgain?: boolean;
    _sharingLocation?: 'canvas' | undefined;
}

export class SharingState {
    @observable selectedImages: any[] = [];

    @observable selectedHistory: any[] = [];

    @observable imagesWidgets: ISharingWidget[] = [];

    @observable isResourcesReadyToBeShared: boolean = false;

    @computed get selectedResources() {
        return {
            images: this.selectedImages,
            history: this.selectedHistory
        };
    }

    @observable shareSelectedImage: ISignedData | null = null;

    @observable sharingModeActions: ISharingModeActions[] = [];
}
